const Footnote = () => {
  return (
    <p
      style={{
        color: '#717171',
        fontSize: '10px',
        margin: 0,
        fontWeight: 500,
      }}
    >
      {' '}
      © 2026 The Simple Platform, Inc. (V1.4.6)
    </p>
  );
};

export default Footnote;
